import { PlanDetails } from '@/contexts/plans'

export function getSelectLabelByPlanMetadata(plan: PlanDetails, prefix = '') {
  let label = plan.commercial_name
  const maximum_tpv = Math.round(plan.metadata?.maximum_tpv || 0) / 1000
  const minimum_tpv = Math.round(plan.metadata?.minimum_tpv || 0) / 1000

  if (plan.metadata?.maximum_duration) {
    label = 'Período Promocional'

    return label
  }

  if (!minimum_tpv && maximum_tpv > 0) {
    label = `${prefix} até R$ ${maximum_tpv} mil`
  }

  if (!maximum_tpv && minimum_tpv > 0) {
    label = `${prefix} acima de R$ ${minimum_tpv} mil`
  }

  if (minimum_tpv > 0 && maximum_tpv > 0 && minimum_tpv !== maximum_tpv) {
    label = `${prefix} de R$ ${minimum_tpv} mil a R$ ${maximum_tpv} mil`
  }

  if (prefix === '') {
    label = label.trim()
    label = label[0].toUpperCase() + label.slice(1)
  }

  return label
}
